import React from 'react';
import './ContentLeft.css';

function ContentLeft() {
  const contentImageStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/img/opener-left.png)`,
  };

  return (
    <section id="about" className="content-left">
      <div className="content-image" style={contentImageStyle} />
      <div className="content-text">
        <h2>Das Geheimnis um Milchkettenmusik</h2>
        <p>
        <strong>Stell dir vor: 1993, Schanzenviertel, Hamburg.</strong><br /><br />
        Drei junge Typen – Jörn, Matthias und Stefan – gründen ein Studio. Milchkettenmusik. Warum der Name? Das verraten wir vielleicht später …
        </p>
        <p>
        Was wir aber sofort verraten können: Schon damals stapelten sich die Bands bei uns. (Fast) die komplette Hamburger Jazz-Szene, dazu viele andere spannende Projekte. Und bis heute ist dieses Studio ein Ort für Begegnungen, Ideen und Musik in allen Farben.
        </p>
        <p>
Heute – mehr als 30 Jahre später – sitzt Matthias am Steuer: Tonmeister, Schlagzeuger. Mit einer Mischung aus Engelsgeduld und teuflischer Akribie kümmert er sich um das, was jede Produktion einzigartig macht.
        </p>
      </div>
    </section>
  );
}

export default ContentLeft;
